import { createRoutine, bindRoutineToReduxForm } from 'redux-saga-routines';

export const forgotPassword = createRoutine('FORGOTPASSWORD');
export const resetPassword = createRoutine('RESETPASSWORD');
export const forgotPasswordFormHandler = bindRoutineToReduxForm(forgotPassword);
export const resetPasswordFormHandler = bindRoutineToReduxForm(resetPassword);
